import {useContext} from "react"
import {RootStore} from "."
import {StoreContext} from "./StoreProvider"

export const useStores = (): RootStore => useContext(StoreContext)
